import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Parcel } from 'src/interfaces/waybill';

@Component({
  selector: 'core-parcel-list',
  templateUrl: './parcel-list.component.html',
  styleUrls: ['./parcel-list.component.scss']
})
export class ParcelListComponent implements OnInit {

  @Input() parcels: Parcel[];
  @Output() onDelete = new EventEmitter<Parcel>();
  @Input() capturing: boolean = false;

  displayedColumns: string[] = [
    'height',
    'length',
    'width',
    'mass',
    'parcel_count', 
    'parcel_number',
    'description',
    'remove'
  ];

  constructor() { 

  }

  ngOnInit(): void {

  }

  deleteParcel(parcel: Parcel) {
    this.onDelete.emit(parcel);
  }

  getMass(parcel: Parcel):number {
    return parcel.mass;
  }

}
